"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getWeekDays;

function getWeekDays() {
  return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
}